import React, { Fragment } from 'react';

import PropTypes from 'prop-types';

import './testimonial.css';
import { useTranslation } from 'react-i18next';

const Testimonial = (props) => {
  const { t } = useTranslation();
  return (
    <div className='thq-section-padding'>
      <div className='testimonial17-max-width thq-section-max-width'>
        <div className='testimonial17-container10'>
          <h2 className='thq-heading-2'>
            {props.heading1 ?? (
              <Fragment>
                <span className='testimonial17-text28'>{t('testimonial.heading')}</span>
              </Fragment>
            )}
          </h2>
        </div>
        <div className='thq-grid-2'>
          <div className='thq-animated-card-bg-2'>
            <div className='thq-animated-card-bg-1'>
              <div data-animated='true' className='thq-card testimonial17-card1'>
                <div className='testimonial17-container12'>
                  <img alt={props.author1Alt} src={props.author1Src} className='testimonial17-image1' />
                  <div className='testimonial17-container13'>
                    <strong className='thq-body-large'>
                      {props.author1Name ?? (
                        <Fragment>
                          <span className='testimonial17-text35'>{t('testimonial.author1Name')}</span>
                        </Fragment>
                      )}
                    </strong>
                    <span className='thq-body-small'>
                      {props.author1Position ?? (
                        <Fragment>
                          <span className='testimonial17-text32'>{t('testimonial.author1Position')}</span>
                        </Fragment>
                      )}
                    </span>
                  </div>
                </div>
                <span className='testimonial17-text13 thq-body-small'>
                  {props.review1 ?? (
                    <Fragment>
                      <span className='testimonial17-text31'>{t('testimonial.review1')}</span>
                    </Fragment>
                  )}
                </span>
              </div>
            </div>
          </div>
          <div className='thq-animated-card-bg-2'>
            <div className='thq-animated-card-bg-1'>
              <div data-animated='true' className='thq-card testimonial17-card2'>
                <div className='testimonial17-container14'>
                  <img alt={props.author2Alt} src={props.author2Src} className='testimonial17-image2' />
                  <div className='testimonial17-container15'>
                    <strong className='thq-body-large'>
                      {props.author2Name ?? (
                        <Fragment>
                          <span className='testimonial17-text25'>{t('testimonial.author2Name')}</span>
                        </Fragment>
                      )}
                    </strong>
                    <span className='thq-body-small'>
                      {props.author2Position ?? (
                        <Fragment>
                          <span className='testimonial17-text34'>{t('testimonial.author2Position')}</span>
                        </Fragment>
                      )}
                    </span>
                  </div>
                </div>
                <span className='testimonial17-text16 thq-body-small'>
                  {props.review2 ?? (
                    <Fragment>
                      <span className='testimonial17-text23'>{t('testimonial.review2')}</span>
                    </Fragment>
                  )}
                </span>
              </div>
            </div>
          </div>
          <div className='thq-animated-card-bg-2'>
            <div className='thq-animated-card-bg-1'>
              <div data-animated='true' className='thq-card testimonial17-card3'>
                <div className='testimonial17-container16'>
                  <img alt={props.author3Alt} src={props.author3Src} className='testimonial17-image3' />
                  <div className='testimonial17-container17'>
                    <strong className='thq-body-large'>
                      {props.author3Name ?? (
                        <Fragment>
                          <span className='testimonial17-text30'>{t('testimonial.author3Name')}</span>
                        </Fragment>
                      )}
                    </strong>
                    <span className='thq-body-small'>
                      {props.author3Position ?? (
                        <Fragment>
                          <span className='testimonial17-text33'>{t('testimonial.author3Position')}</span>
                        </Fragment>
                      )}
                    </span>
                  </div>
                </div>
                <span className='testimonial17-text19 thq-body-small'>
                  {props.review3 ?? (
                    <Fragment>
                      <span className='testimonial17-text27'>{t('testimonial.review3')}</span>
                    </Fragment>
                  )}
                </span>
              </div>
            </div>
          </div>
          <div className='thq-animated-card-bg-2'>
            <div className='thq-animated-card-bg-1'>
              <div data-animated='true' className='thq-card testimonial17-card4'>
                <div className='testimonial17-container18'>
                  <img alt={props.author4Alt} src={props.author4Src} className='testimonial17-image4' />
                  <div className='testimonial17-container19'>
                    <strong className='thq-body-large'>
                      {props.author4Name ?? (
                        <Fragment>
                          <span className='testimonial17-text29'>{t('testimonial.author4Name')}</span>
                        </Fragment>
                      )}
                    </strong>
                    <span className='thq-body-small'>
                      {props.author4Position ?? (
                        <Fragment>
                          <span className='testimonial17-text24'>{t('testimonial.author4Position')}</span>
                        </Fragment>
                      )}
                    </span>
                  </div>
                </div>
                <span className='testimonial17-text22 thq-body-small'>
                  {props.review4 ?? (
                    <Fragment>
                      <span className='testimonial17-text26'>{t('testimonial.review4')}</span>
                    </Fragment>
                  )}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

Testimonial.defaultProps = {
  author1Src:
    'https://images.unsplash.com/photo-1564156280315-1d42b4651629?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w5MTMyMXwwfDF8cmFuZG9tfHx8fHx8fHx8MTc1MDIyMzk3N3w&ixlib=rb-4.1.0&q=80&w=1080',
  review2: undefined,
  author4Position: undefined,
  author2Name: undefined,
  author4Src:
    'https://images.unsplash.com/photo-1498830923224-e1c12d1564a6?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w5MTMyMXwwfDF8cmFuZG9tfHx8fHx8fHx8MTc1MDIzMzYwNXw&ixlib=rb-4.1.0&q=80&w=200',
  review4: undefined,
  review3: undefined,
  heading1: undefined,
  author4Name: undefined,
  author3Name: undefined,
  review1: undefined,
  author1Position: undefined,
  author3Src:
    'https://images.unsplash.com/photo-1601412436465-922fadda062e?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w5MTMyMXwwfDF8cmFuZG9tfHx8fHx8fHx8MTc1MDIyMzk3N3w&ixlib=rb-4.1.0&q=80&w=1080',
  author1Alt: 'Image of John Smith',
  author3Position: undefined,
  author2Alt: 'Image of Emily Jones',
  author3Alt: 'Image of Ahmed Khan',
  author2Src:
    'https://images.unsplash.com/photo-1516908205727-40afad9449a8?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w5MTMyMXwwfDF8cmFuZG9tfHx8fHx8fHx8MTc1MDIzMzczN3w&ixlib=rb-4.1.0&q=80&w=200',
  author2Position: undefined,
  author4Alt: 'Image of Maria Garcia',
  author1Name: undefined,
};

Testimonial.propTypes = {
  author1Src: PropTypes.string,
  review2: PropTypes.element,
  author4Position: PropTypes.element,
  author2Name: PropTypes.element,
  author4Src: PropTypes.string,
  review4: PropTypes.element,
  review3: PropTypes.element,
  heading1: PropTypes.element,
  author4Name: PropTypes.element,
  author3Name: PropTypes.element,
  review1: PropTypes.element,
  author1Position: PropTypes.element,
  author3Src: PropTypes.string,
  author1Alt: PropTypes.string,
  author3Position: PropTypes.element,
  author2Alt: PropTypes.string,
  author3Alt: PropTypes.string,
  author2Src: PropTypes.string,
  author2Position: PropTypes.element,
  author4Alt: PropTypes.string,
  author1Name: PropTypes.element,
};

export default Testimonial;
